import { StatusBar, Style } from '@capacitor/status-bar';
import {
  DEFAULT_THEME_PREFERENCE,
  THEME_PREFERENCE_KEY,
  type ThemePreference,
} from './constants';
import { Preferences } from '@capacitor/preferences';
import { isAndroid, isNative } from '@/domains/shared/utils/native';

export async function syncStatusBarStyle(): Promise<void> {
  if (!isNative()) return;
  // Android 16+: StatusBar plugin is unsupported; bar appearance is driven by
  // CSS safe-zone overlays that follow prefers-color-scheme.
  if (isAndroid()) return;

  const isThemePreference = (value: string | null): value is ThemePreference =>
    value === 'system' || value === 'light' || value === 'dark';

  const { value } = await Preferences.get({ key: THEME_PREFERENCE_KEY });
  const preference = isThemePreference(value)
    ? value
    : DEFAULT_THEME_PREFERENCE;

  switch (preference) {
    case 'dark':
      StatusBar.setStyle({ style: Style.Dark });
      break;
    case 'light':
      StatusBar.setStyle({ style: Style.Light });
      break;
    case 'system':
      StatusBar.setStyle({ style: Style.Default });
      break;
  }
}
